import { useTheme } from '../context/ThemeContext';
import logoIconLight from '../assets/logo-icon.svg';
import logoIconDark from '../assets/logo-icon-dark.svg';
import logoFullLight from '../assets/logo-full-light.svg';
import logoFullDark from '../assets/logo-full-dark.svg';

/**
 * Props:
 *   size      – icon size in px (default 32)
 *   showText  – render the full logo with wordmark (default true)
 *   textClass – unused (kept for API compatibility)
 */
export default function SpocoDocLogo({ size = 32, showText = true, textClass = '' }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (showText) {
    // Full logo: icon + wordmark — switch by theme
    // Use a fixed height tall enough to be readable regardless of the size prop
    const fullHeight = Math.max(size * 1.6, 44);
    const fullSrc = isDark ? logoFullDark : logoFullLight;
    return (
      <img
        src={fullSrc}
        height={fullHeight}
        alt="SpocoDoc"
        style={{ flexShrink: 0, maxHeight: fullHeight }}
      />
    );
  }

  // Icon only — switch by theme
  const iconSrc = isDark ? logoIconDark : logoIconLight;
  return (
    <img
      src={iconSrc}
      width={size}
      height={size}
      alt="SpocoDoc"
      style={{ flexShrink: 0 }}
    />
  );
}
